<template lang="pug">
  .box
    .banner
    .nav
      ul
        li
          a(href="javascript:;") 速云平台
    .productBox
      .twoBody
        h4 案例一：平凉市疫情防控网格化管理服务平台
        .aBox
          img(src="../assets/images/platform/b6.jpg" alt="")
          p 通过简单的托拉拽的方式灵活快速配置表单控件以及平台扩展，在短时间内完成平凉市疫情防控平台的搭建,实现上线上填报、扫码登记，帮助疫情防控争取了更多宝贵时间，解决了人工录入、上报、统计的繁琐步骤，接触传播等问题。
        h4(style="text-align:right;") 案例二：陇政钉
        .bBox
          img(src="../assets/images/platform/b7.jpg" alt="")
          img(src="../assets/images/platform/b8.jpg" alt="" style="float:right;width:40%;")
          p 严谨的应用权限控制，不仅有效的提高平台的安全性，减少误操作、数据泄漏等风险的发生，且有效提升了日常政务工作的效率，职责清晰，自定义LOGO，实现品牌建设。
          p(style="float:right;") 流程可视，流程记录实实同步，审批节点及状态清晰明了，已办未办节点一目了然，审批单据可撤回或转交，线上手签更具法律性，实现了陇政钉线上审批，使其流程更严谨，工作更高效。
        h4 案例三：甘肃农业职业技术学校
        .cBox
          p.one(style="margin-top:30px;") 建立学生学籍电子档案库，批量导入导出实现学生学籍档案在线统一规范管理，通过强大的数据库管理以及搜索引擎实现通过身份证号随时随地快速査询，减少老师工作量，提高信息质量和使用效率，从根本上提高运作质量和响应能力。
          img(src="../assets/images/platform/b10.jpg" alt="")
          img(src="../assets/images/platform/b9.jpg" alt="" style="float:left;")
          p.two(style="float:right;margin-top:50px;") 强大的数据统计（支持柱状图、饼状图、折线图、明细表等多样式数据报表），实现复杂的多表数据的处理，得到经过数据流聚合计算后的数据，为学校建立了大数据管理后台，科学智能统计为学校管理提供的决策支持。
        h4(style="text-align:right;") 案例四：兰州龙华实业集团
        .dBox
          p 通过业务规则的配置，预警提醒等功能，使之形成一套完整的供应链系统,层次清晰，管理清晰，实现商品出入库线上管理，方便、直观地监控和管理出库订单工作流，并实时查看瓶颈和资产利用情况。
          img(src="../assets/images/platform/b11.jpg" alt="")
</template>

<script>
export default {
  data () {
    return {
      flag: 1
    }
  },
  created () {
    this.$store.commit('changeNav', 3)
  },
  methods: {
    one () {
      this.flag = 1
      this.$router.push('/platform')
    }
  },
  mounted () {
    document.title = '速云官网'
  }
}
</script>

<style lang="less" scoped>
  .banner{
    width: 100%;
    height: 386px;
    background-image: url(../assets/img/bannera.jpg);
    background-size: cover;
    background-position: 50%;
  }
  .nav{
    height: 95px;
    width: 100%;
    ul{
      width: 70%;
      height: 95px;
      margin: 0 auto;
      li{
        width: 100px;
        margin-right: 50px;
        padding: 28px 0;
        cursor: pointer;
        border-bottom: 3px solid #007BF9;
        a{
          font-size: 24px;
          color: #333;
        }
      }
    }
  }
  .productBox{
    border-top: 1px solid #E6E6E6;
    padding: 0 15% 20px;
    .twoBody{
      text-align: justify;
      img{
        vertical-align: top;
        margin-top: 10px;
      }
      h4{
        margin:20px 0;
        font-weight: 400;
      }
      .aBox{
        img{
          width: 50%;
        }
        p{
          float: right;
          width: 30%;
          background-color: #f0f0f0;
          padding: 40px;
          border-radius: 10px;
          box-shadow: -1px 1px 4px rgba(0, 0, 0, .5);
          margin-top: 112px;
        }
      }
      .bBox{
        overflow: hidden;
        img{
          width: 55%;
        }
        p{
          float: left;
          width: 40%;
          padding: 20px;
          line-height: 26px;
          border: 1px dashed #409fee;
          border-radius: 10px;
          text-indent: 2em;
          margin: 10px 0 0 30px;
        }
      }
      .cBox{
        overflow: hidden;
        img{
          float: right;
          width: 60%;
        }
        p{
          position: relative;
          float: left;
          width: 35%;
          border: 1px solid #409fee;
          border-radius: 10px;
          padding: 20px;
          text-indent: 2em;
          line-height: 26px;
        }
        .one::after{
          content: '';
          position: absolute;
          bottom: -11px;
          left: 170px;
          width: 20px;
          height: 20px;
          border-top: 1px solid #409fee;
          border-right: 1px solid #409fee;
          transform: rotate(135deg);
          background-color: #f9f9f9;
        }
        .two::before{
          content: '';
          position: absolute;
          top: -11px;
          left: 170px;
          width: 20px;
          height: 20px;
          border-top: 1px solid #409fee;
          border-right: 1px solid #409fee;
          transform: rotate(-45deg);
          background-color: #f9f9f9;
        }
      }
      .dBox{
        overflow: hidden;
        p{
          float: right;
          border-radius: 10px;
          width: 32%;
          padding: 60px 20px;
          line-height: 26px;
          text-indent: 2em;
          margin-top: 50px;
          background-image: url(../assets/images/platform/bc3.jpg);
          background-size: cover;
        }
        img{
          float: left;
          width: 60%;
        }
      }
    }
  }
</style>
